import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import { Typeahead } from './Typeahead';
import { fetchUsers } from '../../apis';
import { Map } from 'immutable';
var emailPattern = /^.+@.+\..+$/;

var validateCustomOption = function validateCustomOption(value) {
  return value.match(emailPattern);
};

var fields = {
  username: 'Username',
  displayName: 'Display Name',
  email: 'Email'
};

var searchUsers = function searchUsers(_ref) {
  var _ref$search = _ref.search,
      search = _ref$search === void 0 ? Map() : _ref$search;
  return function (searchField, value, callback) {
    return fetchUsers({
      q: Object.keys(fields).filter(function (field) {
        return !searchField || field === searchField;
      }).map(function (field) {
        return "".concat(field, " =* \"").concat(value, "\"");
      }).join(' OR '),
      limit: search.get('limit') || 25,
      include: search.get('include') || ''
    }).then(function (_ref2) {
      var users = _ref2.users,
          error = _ref2.error,
          nextPageToken = _ref2.nextPageToken;
      return {
        suggestions: users || [],
        error: error,
        nextPageToken: nextPageToken
      };
    }).then(callback);
  };
};

var userToValue = function userToValue(user) {
  return user && (user.get('username') || user.get('email') || '') || '';
}; // Converts a typed in value to an option object. Used when adding custom values
// when allowNew is true.


var valueToCustomUser = function valueToCustomUser(_ref3) {
  var allowNew = _ref3.allowNew;
  return function (value) {
    return value.length > 0 ? typeof allowNew === 'function' && allowNew(value) || validateCustomOption(value) ? {
      email: value
    } : null : null;
  };
};

var getStatusProps = function getStatusProps(_ref4) {
  var _ref4$search = _ref4.search,
      search = _ref4$search === void 0 ? Map() : _ref4$search,
      _ref4$messages = _ref4.messages;
  _ref4$messages = _ref4$messages === void 0 ? {} : _ref4$messages;

  var _ref4$messages$short = _ref4$messages["short"],
      _short = _ref4$messages$short === void 0 ? 'Type to find a user.' : _ref4$messages$short,
      _ref4$messages$empty = _ref4$messages.empty,
      empty = _ref4$messages$empty === void 0 ? 'No matching users.' : _ref4$messages$empty,
      _ref4$messages$custom = _ref4$messages.custom,
      custom = _ref4$messages$custom === void 0 ? 'No matching users. You may also enter a valid email.' : _ref4$messages$custom,
      _ref4$messages$pendin = _ref4$messages.pending,
      pending = _ref4$messages$pendin === void 0 ? 'Searching...' : _ref4$messages$pendin,
      _ref4$messages$more = _ref4$messages.more,
      more = _ref4$messages$more === void 0 ? "Too many users, first ".concat(search.get('limit') || '', " shown. Please refine your search.") : _ref4$messages$more,
      _ref4$messages$error = _ref4$messages.error,
      error = _ref4$messages$error === void 0 ? 'There was an error fetching users.' : _ref4$messages$error;

  return function (props) {
    return {
      meta: props.searchField ? "Find Users by ".concat(fields[props.searchField]) : null,
      info: props["short"] ? _short : props.pending ? pending : null,
      warning: props.error || props.more || props.empty ? props.error && props.error.key === 'too_many_matches' ? 'Too many users to display. Please refine your search below.' : props.more ? more : props.empty && !props.custom ? empty : props.empty && props.custom ? custom : error : null,
      clearFilterField: props.searchField ? props.setSearchField(null) : null,
      filterFieldOptions: props.error && props.error.key === 'too_many_matches' ? Object.entries(props.error.errorData.matches).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            field = _ref6[0],
            count = _ref6[1];

        return {
          field: field,
          count: count,
          label: fields[field],
          value: props.value,
          onClick: props.setSearchField(field)
        };
      }) : null
    };
  };
};

export var UserSelect = function UserSelect(props) {
  return /*#__PURE__*/React.createElement(Typeahead, {
    components: props.components || {},
    disabled: props.disabled,
    multiple: props.multiple,
    custom: props.allowNew && valueToCustomUser(props),
    search: searchUsers(props),
    minSearchLength: props.minSearchLength,
    getSuggestionValue: userToValue,
    getStatusProps: getStatusProps(props),
    value: props.value,
    onChange: props.onChange,
    onFocus: props.onFocus,
    onBlur: props.onBlur,
    placeholder: props.placeholder
  });
};